import React, { useState } from "react";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomModal,
  ImageUploader,
} from "../../../../components";
import Context from "../../../../context";
import "./index.sass";
import { Container, Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";
import { CATEGORY_BASE } from "../../../../values/dropdownItems";
import { IItem } from "../../../../types/common.interface";
import api from "../../../../api";
import { useFormik } from "formik";
import * as Yup from "yup";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createCategory, loading } = React.useContext(
    Context.CategoryScreen
  );

  const [categoryBase, setCategoryBase] = useState<IItem>();
  const [selectedImage, setSelectedImage] = useState<any>();
  const [errors, setErrors] = useState<{
    baseCategory?: string;
    image?: string;
  }>({
    baseCategory: "",
    image: "",
  });

  // function submitCarInformation(event: ICreateAndUpdateDriver) {
  //   updateFunction!({ ...formData, ...event });
  // }

  console.log(selectedImage);

  const formik = useFormik({
    initialValues: {
      categoryName: "",
    },
    validationSchema: Yup.object({
      categoryName: Yup.string()
        .required("نام دسته بندی اجباری است")
        .min(2, "حداقل دو حرف وارد کنید"),
    }),
    onSubmit: (values) => {
      if (categoryBase) {
        createCategory!({
          categoryName: values?.categoryName,
          type: categoryBase?._id,
          image: selectedImage?.link,
        });
      }
    },
  });

  const submitHandler = () => {
    let errors = {
      baseCategory: "",
      image: "",
    };
    if (!categoryBase) {
      errors = { ...errors, baseCategory: "نوع دسته بندی را انتخاب کنید" };
    }
    if (!selectedImage) {
      errors = { ...errors, image: "تصویر دسته بندی را انتخاب کنید" };
    }

    setErrors(errors);

    formik.submitForm();
  };

  async function onUploadImage(imageFile: File) {
    const imagePromise = await api.postMethod.common.uploadImage!(imageFile);
    if (imagePromise?.CODE === 2010) setSelectedImage(imagePromise?.result);
  }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-update-modal-container">
      <CustomIcon
        icon="fa fa-add"
        onClick={() => setShowModal!("CREATE")}
        size="medium"
        hoverTitle="ساخت دسته بندی"
      />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
        maxWidth={"25rem"}
      >
        <form>
          <Container>
            <Row>
              <Column medium={12} className="form-colum dropdown">
                <p className="form-label">نوع دسته بندی:</p>
                <CustomDropdownSearch
                  items={CATEGORY_BASE}
                  itemName="name"
                  defaultItem={categoryBase}
                  onSelectItem={(event) => {
                    setCategoryBase(event);
                    setErrors({ ...errors, baseCategory: "" });
                  }}
                  placeHolder="انتخاب نوع دسته بندی"
                />
                <div className="error">
                  {errors.baseCategory !== "" && errors.baseCategory}
                </div>
              </Column>

              <Column medium={12} className="form-colum">
                <CustomInput
                  name="categoryName"
                  id="categoryName"
                  label={"عنوان دسته بندی"}
                  value={formik.values.categoryName}
                  onValueChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.categoryName && formik.touched.categoryName
                  }
                  errorText={formik.errors.categoryName}
                />
              </Column>
              <Column medium={12} className="dropdown form-colum">
                <ImageUploader
                  label="تصویر دسته بندی"
                  defaultImage={selectedImage}
                  setImage={setSelectedImage}
                  uploadImage={(event: any) => {
                    onUploadImage(event);
                    setErrors({ ...errors, image: "" });
                  }}
                />{" "}
                <div className="error">
                  {errors.image !== "" && errors.image}
                </div>
              </Column>
            </Row>
            <Row>
              <Column>
                <CustomButton2
                  title={"ثبت"}
                  type="primary"
                  onClick={submitHandler}
                  isLoading={loading}
                />
              </Column>
            </Row>
          </Container>
        </form>
      </CustomModal>
    </section>
  );
};

export default Create;
